import OrdemServicoService from "@/services/OrdemServicoService";

export const ordemServico = {
  namespaced: true,
  state: {
    ordemServico: {},
  },
  actions: {
    getOrdemServico({ commit }, payload) {
      return OrdemServicoService.GetOrdemServico(payload).then(
        (ordemServico) => {
          return Promise.resolve(ordemServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postOrdemServico({ commit }, payload) {
      return OrdemServicoService.PostOrdemServico(payload).then(
        (ordemServico) => {
          return Promise.resolve(ordemServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putOrdemServico({ commit }, payload) {
      return OrdemServicoService.PutOrdemServico(payload).then(
        (ordemServico) => {
          return Promise.resolve(ordemServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteOrdemServico({ commit }, payload) {
      return OrdemServicoService.DeleteOrdemServico(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getOrdemServicoOData({ commit }, payload) {
      return OrdemServicoService.GetOrdemServicoOData(payload).then(
        (ordemServico) => {
          return Promise.resolve(ordemServico);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    atualizarFaturamentoOrdemServico({ commit }, payload) {
      return OrdemServicoService.AtualizarFaturamento(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    imprimirOrdemServico({ commit }, payload) {
      return OrdemServicoService.ImprimirOrdemServico(payload).then(
        (ordemServico) => {
          return Promise.resolve(ordemServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default ordemServico;
